import { render } from "./MessageDisplay.vue?vue&type=template&id=091eac13&scoped=true"
import script from "./MessageDisplay.vue?vue&type=script&lang=js"
export * from "./MessageDisplay.vue?vue&type=script&lang=js"

import "./MessageDisplay.vue?vue&type=style&index=0&id=091eac13&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091eac13"]])

export default __exports__